<template>
    <div class="list-in-ex-type-1" :class="{'sm-horizontal': smHorizontal}">
        <template v-for="list in displayLists" :key="list">
            <div class="list-container" :class="list + '-list'" v-if="showEmpty || getDisplayItems(list).length > 0">
                <h3 class="title">{{ $t(getTranslationKey(list, 'label')) }}:</h3>
                <ul class="items-list">
                    <template v-if="getDisplayItems(list).length > 0">
                        <li v-for="item in getDisplayItems(list)" :key="`${list}-${item.value}`" 
                            class="list-item" 
                            :class="{'required-item': isRequired(item)}">
                            <div class="item-name">
                                <span>{{ item[displayValue] }}</span>
                                <span v-if="isRequired(item)" class="required-badge">
                                    {{ $t('common.required_1') }}
                                </span>
                            </div>
                            <div v-if="item.icon" class="item-icon">
                                <img :src="item.icon" />
                            </div>
                            <div class="item-actions">
                                <template v-if="list === 'includes'">
                                    <button v-if="isRequired(item)" v-tooltip="showTooltips ? 'tooltips.required' :''" class="btn-unstar" @click="makeOptional(item)">
                                        <div class="icon-star-neg"></div>
                                    </button>
                                    <button v-else-if="showRequired" v-tooltip="showTooltips ? 'tooltips.required' :''" class="btn-star" @click="makeRequired(item)">
                                        <div class="icon-star-neg"></div>
                                    </button>

                                    <button class="btn-exclude" v-tooltip="showTooltips ? 'tooltips.exclude' :''" @click="moveToExcludes(item)">
                                        <div class="icon-arrow-neg"></div>
                                    </button>
                                </template>
                                <template v-else-if="list === 'excludes'">
                                    <button class="btn-include" v-tooltip="showTooltips ? 'tooltips.include' :''" @click="moveToIncludes(item)">
                                        <div class="icon-arrow-neg"></div>
                                    </button>
                                </template>
                                <button class="btn-remove" v-tooltip="showTooltips ? 'tooltips.trash' :''" @click="removeItem(item, isRequired(item) ? 'required' : list)">
                                    <div class="icon-trash-neg"></div>
                                </button>
                            </div>
                        </li>
                    </template>
                    <template v-else>
                        <li class="empty">{{ $t(getTranslationKey(list, 'empty')) }}</li>
                    </template>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "CustomIncludesExcludes",
        props: {
            modelValue: {
                type: Object,
                default: () => ({ includes: [], excludes: [], required: [] })
            },
            inputKey: {
                type: String,
                default: ''
            },
            showEmpty: {
                type: Boolean,
                default: true
            },
            showRequired: {
                type: Boolean,
                default: false
            },
            displayValue: {
                type: String,
                default: 'text'
            },
            smHorizontal: {
                type: Boolean,
                default: false
            },
            showTooltips: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                displayLists: ['includes', 'excludes']
            }
        },
        computed: {
            includes() {
                return this.modelValue?.includes || [];
            },
            excludes() {
                return this.modelValue?.excludes || [];
            },
            required() {
                return this.modelValue?.required || [];
            }
        },
        methods: {
            isRequired(item) {
                return this.required.some(req => req.value === item.value);
            },
            getDisplayItems(list) {
                if (list === 'includes') {
                    return [...this.required, ...this.includes];
                }
                return this.modelValue[list] || [];
            },
            getTranslationKey(listType, keyType) {
                const keys = {
                    includes: {
                        label: 'includes',
                        action: 'exclude',
                        empty: 'none_included'
                    },
                    excludes: {
                        label: 'excludes',
                        action: 'include',
                        empty: 'none_excluded'
                    },
                    required: {
                        action: 'make_optional',
                        badge: 'required_badge'
                    },
                    includes_to_required: {
                        action: 'make_required'
                    }
                };
                
                const suffix = keys[listType][keyType];
                
                if (this.inputKey && this.$te(`fields.${this.inputKey}.list_in_ex.${suffix}`)) {
                    return `fields.${this.inputKey}.list_in_ex.${suffix}`;
                }
                
                return `fields.list_in_ex.${suffix}`;
            },
            moveToExcludes(item) {
                const newValue = {
                    includes: [...this.includes].filter(x => x.value !== item.value),
                    excludes: [...this.excludes, item],
                    required: [...this.required].filter(x => x.value !== item.value)
                };
                this.$emit('update:modelValue', newValue);
            },
            moveToIncludes(item) {
                const newValue = {
                    includes: [...this.includes, item],
                    excludes: [...this.excludes].filter(x => x.value !== item.value),
                    required: [...this.required]
                };
                this.$emit('update:modelValue', newValue);
            },
            makeRequired(item) {
                const newValue = {
                    includes: [...this.includes].filter(x => x.value !== item.value),
                    excludes: [...this.excludes],
                    required: [...this.required, item]
                };
                this.$emit('update:modelValue', newValue);
            },
            makeOptional(item) {
                const newValue = {
                    includes: [...this.includes, item],
                    excludes: [...this.excludes],
                    required: [...this.required].filter(x => x.value !== item.value)
                };
                this.$emit('update:modelValue', newValue);
            },
            removeItem(item, list) {
                const newValue = { ...this.modelValue };
                newValue[list] = newValue[list].filter(x => x.value !== item.value);
                this.$emit('update:modelValue', newValue);
            }
        }
    }
</script>
